import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Container, Row, Col, Card, ListGroup, Image } from 'react-bootstrap';
import { DragDropContext } from 'react-beautiful-dnd';
import Column from './column/column';
import Loader from '../../../utilityComponents/Loader';
import Message from '../../../utilityComponents/Message';
import Description from '../../../utilityComponents/Description';
import { getScenarioGroupDetails, updateScenarioGroupDetails } from '../../../actions/bulkScenarioGroup/bulkScenarioGroupActions';
import ScenarioGroupCreation from './scenarioGroupCreation/scenarioGroupCreation';
import { Link } from 'react-router-dom'
import Breadcrumb from 'react-bootstrap/Breadcrumb'

function BulkScenarioGroup(props) {

    const { info, loading, error, scenarioInfo } = props;
    const baseURL = 'data:image/png;base64,';

    useEffect(() => {
        props.fetchScenarioInfo();
    }, [])

    const onDragEnd = (result) => {
        const { destination, source, draggableId } = result;

        if (!destination) {
            return;
        }

        if (
            destination.droppableId === source.droppableId &&
            destination.index === source.index
        ) {
            return;
        }

        const start = props.info.columns[source.droppableId];
        const finish = props.info.columns[destination.droppableId];

        if (start === finish) {
            const newTaskIds = Array.from(start.taskIds);
            newTaskIds.splice(source.index, 1);
            newTaskIds.splice(destination.index, 0, draggableId);

            const newColumn = {
                ...start,
                taskIds: newTaskIds,
            };

            const newState = {
                ...props.info,
                columns: {
                    ...props.info.columns,
                    [newColumn.id]: newColumn,
                },
            };

            props.updateScenarioInfo(newState);
            return;
        }

        // Moving from one list to another
        const startTaskIds = Array.from(start.taskIds);
        startTaskIds.splice(source.index, 1);
        const newStart = {
            ...start,
            taskIds: startTaskIds,
        };

        const finishTaskIds = Array.from(finish.taskIds);
        finishTaskIds.splice(destination.index, 0, draggableId);
        const newFinish = {
            ...finish,
            taskIds: finishTaskIds,
        };

        const newState = {
            ...props.info,
            columns: {
                ...props.info.columns,
                [newStart.id]: newStart,
                [newFinish.id]: newFinish,
            },
        };
        props.updateScenarioInfo(newState);
    }

    return (
        <Container fluid="md">
            <Breadcrumb>
                <Breadcrumb.Item href="">
                    <Link to='navigate_new'>Home</Link></Breadcrumb.Item>
                <Breadcrumb.Item href="">
                    <Link to='/welcome'>Welcome</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item href="" > <Link to='/close_loop'>Close loop</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item href="/scenario_group/bulk_creation" active >
                    Bulk Scenario Grouping
                </Breadcrumb.Item>
            </Breadcrumb>

            {error && <Message variant='danger'>{error}</Message>}
            {loading ? <Loader />
                : info ? (
                    <>
                        <h1 style={{ paddingTop: '2%' }}>Bulk Scenario Grouping</h1>
                        <Row style={{ paddingTop: '3%' }}>
                            <Col xs={4}>
                                <Card>
                                    <Card.Header style={{ backgroundColor: '#753DFF' }}>
                                        <h3 style={{ color: '#FFFFFF' }}>Scenario Information</h3>
                                    </Card.Header>
                                    <Card.Body style={{ height: '400px', overflowY: 'scroll' }}>
                                        {scenarioInfo ? (
                                            <ListGroup>
                                                <ListGroup.Item>
                                                    <Row>
                                                        <Col>
                                                            <h4>Variations : </h4>
                                                            <h4>{scenarioInfo.variation_count}</h4>
                                                        </Col>
                                                    </Row>
                                                </ListGroup.Item>
                                                <ListGroup.Item>
                                                    <Row>
                                                        <Col>
                                                            {scenarioInfo.image.includes('https://cclp-') ?
                                                                (
                                                                    <Image
                                                                        fluid
                                                                        src={scenarioInfo.image}
                                                                        alt='No Image Found'
                                                                    />
                                                                ) : (
                                                                    <Image
                                                                        fluid
                                                                        src={`${baseURL}${scenarioInfo.image.replace(/['"]+/g, '')}`}
                                                                        alt='No Image Found'
                                                                    />
                                                                )}
                                                        </Col>
                                                    </Row>
                                                </ListGroup.Item>
                                                <ListGroup.Item>
                                                    <Row>
                                                        <Col>
                                                            <h4>Description : </h4>
                                                            <Description>{scenarioInfo.description}</Description>
                                                        </Col>
                                                    </Row>
                                                </ListGroup.Item>
                                            </ListGroup>
                                        ) : (
                                            <Message variant='info'>
                                                Click the <strong>INFO</strong> button
                                                to get information about the scenario.
                                            </Message>
                                        )}
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col xs={8}>
                                <Row>
                                    <DragDropContext onDragEnd={onDragEnd}>
                                        {props.info.columnOrder.map(columnId => {
                                            const column = props.info.columns[columnId];
                                            const tasks = column.taskIds.map(taskId => props.info.tasks[taskId]);

                                            return <Column key={column.id} column={column} tasks={tasks} />;
                                        })}
                                    </DragDropContext>
                                </Row>
                            </Col>
                        </Row>
                        <Row style={{ paddingTop: '2%' }}>
                            <Col>
                                <ScenarioGroupCreation />
                            </Col>
                        </Row>
                    </>
                ) : undefined}
        </Container>
    );
}


const mapStateToProps = (state) => ({
    loading: state.bulkScenarioGroup.loading,
    error: state.bulkScenarioGroup.error,
    info: state.bulkScenarioGroup.info,
    scenarioInfo: state.scenarioInformation.scenarioInfo,
})

const mapStateToDispatch = (dispatch) => ({
    fetchScenarioInfo: () => dispatch(getScenarioGroupDetails()),
    updateScenarioInfo: (data) => dispatch(updateScenarioGroupDetails(data))
})


export default connect(mapStateToProps, mapStateToDispatch)(BulkScenarioGroup);
